/**
 * SortOptions, a component to sort/filter hikes.
 */

import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {SPRING, theme} from '../../styles';
import {MuiThemeProvider} from '@material-ui/core/styles';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

const activities = {
    ALL: {title: 'All', id: 'all'},
    HIKING: {title: 'Hiking', id: 'hiking'},
    DRIVING: {title: '4x4', id: '4x4'}
};

export default class SortOptions extends React.Component {
    constructor(props) {
        super(props);
        const max = parseInt(props.maxDistance);
        let selectedIndex = 0;
        if (max === 5) {
            selectedIndex = 1;
        } else if (max === 10) {
            selectedIndex = 2;
        } else if (max > 10000) {
            selectedIndex = 3;
        }
        let activity = activities.ALL.id;
        if (props.activity) {
            activity = props.activity;
        }
        this.state = {
            sort: props.sort,
            selectedIndex: selectedIndex,
            activity: activity
        };
    }

    renderSortOption(sortType) {
        let className = 'sort-choice';
        let sortSymbol = '▼';
        if (this.props.orderBy === 'asc') {
            sortSymbol = '▲';
        }
        if (this.state.sort !== sortType.toLowerCase()) {
            sortSymbol = null;
            className = null;
        }
        return (
            <span className={className}><a
                style={{color: SPRING}}
                href="#"
                title={sortType}
                onClick={e => { e.preventDefault(); this.changeSort(sortType.toLowerCase()); }}
            >{sortType}</a>{sortSymbol}</span>
        );
    }

    renderActivityOption(activity) {
        // eslint-disable-next-line eqeqeq
        if (this.state.activity == activity.id) {
            return (
                <span className="sort-choice">{activity.title}</span>
            );

        } else {
            return (

                <span>
                    <a
                        style={{color: SPRING}}
                        href="#"
                        title={activity.title}
                        onClick={e => { e.preventDefault(); this.changeDrivableFilter(activity); }}
                    >{activity.title}</a>
                </span>
            );
        }
    }

    render() {
        let unitString = 'miles';
        if (this.props.useMetric) {
            unitString = 'km';
        }

        // allow underlines on distance Select
        const underlineTheme = Object.assign({}, theme);
        underlineTheme.overrides = null;
        return (
            <span className="filter-container">
                <h2>Sort</h2>&nbsp;
                {this.renderSortOption('Rank')}
                {this.renderSortOption('Time')}
                {this.renderSortOption('Stars')}
                {this.renderSortOption('Difficulty')}
                {this.renderSortOption('Length')}
                <br />
                <h2>Length</h2>&nbsp;&nbsp;&nbsp;
                <div className="distance-filter-container">
                    <MuiThemeProvider theme={underlineTheme}>
                        <FormControl >
                            <Select
                                value={this.state.selectedIndex}
                                onChange={e => this.refreshHikeList(e.target.value)}
                            >
                                <MenuItem value={0}>1-20 {unitString}</MenuItem>
                                <MenuItem value={1}>1-5 {unitString}</MenuItem>
                                <MenuItem value={2}>5-10 {unitString}</MenuItem>
                                <MenuItem value={3}>10+ {unitString}</MenuItem>
                            </Select>
                        </FormControl>
                    </MuiThemeProvider>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;
                <h2>Activity</h2>&nbsp;&nbsp;&nbsp;
                {this.renderActivityOption(activities.ALL)}
                {this.renderActivityOption(activities.HIKING)}
                {this.renderActivityOption(activities.DRIVING)}
            </span>
        );
    }

    changeSort(sort) {
        trackAnalytics('Sort Hikes', {category: 'Hike', sort: sort});
        let url = window.location.href;
        let orderBy = null;

        if (this.props.orderBy == null || sort !== this.props.sort) {
            if (sort === 'time' || sort === 'difficulty' || sort === 'length') {
                orderBy = 'asc';
            } else {
                orderBy = 'desc';
            }
        } else if (this.props.orderBy === 'asc') {
            orderBy = 'desc';
        } else {
            orderBy = 'asc';
        }
        // don't display order_by parameter for default rank descending search
        if (sort !== 'rank' || orderBy === 'asc') {
            url = window.hikeAppRoot.updateQueryString('sort', sort, url);
            url = window.hikeAppRoot.updateQueryString('order_by', orderBy, url);
        } else {
            url = window.hikeAppRoot.updateQueryString('sort', null, url);
            url = window.hikeAppRoot.updateQueryString('order_by', null, url);
        }
        window.location.href = url;
    }

    changeDrivableFilter(activity) {
        trackAnalytics('Drivable Filter Hikes', {
            category: 'Hike',
            activity: activity.id
        });
        let url = window.location.href;
        if (activity === activities.ALL) {
            url = window.hikeAppRoot.updateQueryString('activity', null, url);
        } else {
            url = window.hikeAppRoot.updateQueryString('activity', activity.id, url);
        }
        window.location.href = url;
    }

    refreshHikeList(selectedIndex) {
        const values = [
            {min: 1, max: 20},
            {min: 1, max: 5},
            {min: 5, max: 10},
            {min: 10, max: 10000}
        ];
        const value = values[selectedIndex];
        const logString = `${value.min}-${value.max}`;
        trackAnalytics('Distance Filter Hikes', {category: 'Hike', range: logString});
        let url = window.location.href;
        url = window.hikeAppRoot.updateQueryString('min_length', value.min, url);
        url = window.hikeAppRoot.updateQueryString('max_length', value.max, url);
        const units = this.props.useMetric ? 'km' : 'mi';
        url = window.hikeAppRoot.updateQueryString('units', units, url);
        window.location.href = url;
    }
}
